import { researchGroupListingSection } from '@stereoagency/sanity-schema';
import compact from 'just-compact';
import { $globalSanityClient } from '@/sanity';
import { researchGroupQuery } from './researchGroupQuery';
import UIResearchGroupListingSection from './ResearchGroupListingSection.client';

type Props =
  typeof researchGroupListingSection.schema.researchGroupListingSection;

export default async function ResearchGroupListingSection({
  title,
  subtitle,
  enableTaxonomyFilter,
  staticFilter
}: Props) {
  const data = await $globalSanityClient.fetch<(typeof researchGroupQuery)[1]>(
    researchGroupQuery[0],
    {
      // only use the staticFilter on server if this block is not filterable
      taxonomies: !enableTaxonomyFilter
        ? staticFilter?.map((tax) => tax._ref) ?? []
        : []
    }
  );

  return (
    <UIResearchGroupListingSection
      title={title}
      subtitle={subtitle}
      enableTaxonomyFilter={enableTaxonomyFilter}
      defaultFilters={compact(staticFilter?.map((tax) => tax._ref) ?? [])}
      groups={data}
    />
  );
}
